<template>
  <div class="rich-editor" :class="{ 'is-disabled': disabled }">
    <div v-show="!disabled" ref="toolbarRef" class="rich-editor__toolbar"></div>
    <div
      ref="editorRef"
      class="rich-editor__body"
      :style="{ height: height }"
    ></div>
  </div>
</template>

<script>
import { loadWangEditor } from "@/utils/wangeditor-editor-bridge";
import { uploadFile } from "@/utils/alioss.js";

export default {
  name: "RichEditor",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "请输入内容"
    },
    height: {
      type: String,
      default: "280px"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "default"
    }
  },
  data() {
    return {
      editor: null,
      toolbar: null,
      syncing: false,
      destroyed: false
    };
  },
  watch: {
    value(val) {
      if (!this.editor || this.syncing) return;
      const next = val || "";
      const current = this.editor.getHtml();
      if (next !== current) {
        this.editor.setHtml(next);
      }
    },
    disabled(val) {
      if (!this.editor) return;
      if (val) {
        this.editor.disable();
      } else {
        this.editor.enable();
      }
    }
  },
  mounted() {
    this.destroyed = false;
    this.$nextTick(() => {
      this.initEditor();
    });
  },
  beforeDestroy() {
    this.destroyed = true;
    this.destroyEditor();
  },
  methods: {
    async uploadByOss(file) {
      const fileType =
        (file.type && file.type.split("/")[0]) ||
        (file.name && file.name.match(/\.(mp4|webm|ogg|mkv)$/i) ? "video" : "image");
      const res = await uploadFile(fileType, file, file.name);
      if (res && res.res && res.res.status === 200 && res.res.requestUrls) {
        return res.res.requestUrls[0];
      }
      throw new Error("upload failed");
    },
    async initEditor() {
      if (!this.$refs.editorRef) return;
      try {
        const api = await loadWangEditor();
        if (this.destroyed || !this.$refs.editorRef) return;
        const editor = api.createEditor({
          selector: this.$refs.editorRef,
          html: this.value || "",
          config: {
            placeholder: this.placeholder,
            readOnly: this.disabled,
            MENU_CONF: {
              uploadImage: {
                customUpload: async (file, insertFn) => {
                  try {
                    const url = await this.uploadByOss(file);
                    insertFn(url, file.name || "", url);
                  } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                    this.$message && this.$message.error("图片上传失败");
                  }
                }
              },
              uploadVideo: {
                customUpload: async (file, insertFn) => {
                  try {
                    const url = await this.uploadByOss(file);
                    insertFn(url, file.name || "");
                  } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                    this.$message && this.$message.error("视频上传失败");
                  }
                }
              }
            },
            onChange: ed => {
              const html = ed.getHtml();
              this.syncing = true;
              this.$emit("input", html);
              this.$emit("change", html);
              this.$nextTick(() => {
                this.syncing = false;
              });
            }
          },
          mode: this.mode
        });
        // Vue2 会对 data 做响应式劫持，与 Slate/Immer 冲突；必须 seal
        this.editor = Object.seal(editor);
        if (!this.disabled && this.$refs.toolbarRef) {
          const toolbar = api.createToolbar({
            editor,
            selector: this.$refs.toolbarRef,
            config: {
              excludeKeys: ["fullScreen"]
            },
            mode: this.mode
          });
          this.toolbar = Object.seal(toolbar);
        }
        if (this.disabled) {
          this.editor.disable();
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.$message && this.$message.error("富文本编辑器加载失败");
      }
    },
    destroyEditor() {
      if (this.editor) {
        try {
          this.editor.destroy();
        } catch (e) {}
        this.editor = null;
      }
      this.toolbar = null;
    }
  }
};
</script>

<style lang="less" scoped>
.rich-editor {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;

  &__toolbar {
    border-bottom: 1px solid #ebeef5;
  }

  &__body {
    overflow-y: auto;
  }

  &.is-disabled {
    background: #f5f7fa;
  }
}

.rich-editor /deep/ .w-e-text-container {
  background: transparent;
}

.rich-editor /deep/ .w-e-text-placeholder {
  color: #c0c4cc;
}

.rich-editor /deep/ .w-e-toolbar {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/RichEditor.vue